module.exports = __webpack_public_path__ + "static/media/img-background4.726d6421.jpg";